import { useCustomerSupport } from './useCustomerSupport';

// TODO we may have more logic in this component in future

export function CustomerSupport(): null {
  useCustomerSupport();
  return null;
}
